import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="dismiss-getting-started"
export default class extends Controller {
  connect() {
    this.form = this.element.closest("form");
    this.element.addEventListener("click", this.dismiss);
  }

  disconnect() {
    this.element.removeEventListener("click", this.dismiss);
  }

  dismiss(e) {
    e.preventDefault();
    document
      .querySelector(".dashboard-onboarding")
      .classList.add("animate-out");
    setTimeout((event) => {
      this.form.requestSubmit();
    }, 300);
  }
}
